import { WebcalendarTypes } from "../../moreCoreCalendar/WebCalendarTypes";

export {
    SyncFusionCalendarTypes
}

namespace SyncFusionCalendarTypes {
    export interface Syncfusion_EventData<T> {
        DataGroupValues: Array<string>,
        items: Array<WebcalendarTypes.WebCalendarItemData_Default>
    }
    export interface Syncfusion_EventItem<T> {
        Id: string,
        eventId: string,
        Subject: string;
        StartTime: string;
        EndTime: string;
        GroupId: string;
        ResourceId: string;
        ResourceGroupId?: string;
        IsAllDay: boolean,
        Object: T,
        Location: string
    }

    export interface Syncfusion_ScheduleObject {
        selectedDate: Date,
        currentView: WebcalendarTypes.SyncfusionCalendar_ViewModes,
        group: {
            resources: Array<{
                dataSource: any
            }>
        }
    }


    export interface EventGroup { id: string, text: string };

    export interface YearViewSettings {
        firstMonthOfYear?: number,
        monthsCount?: number,
        initialized?: boolean
    }


    export interface ScheduleObject_Stump {
        currentView: WebcalendarTypes.SyncfusionCalendar_ViewModes,
        firstMonthOfYear?: number,
        monthsCount?: number,
        firstDayOfWeek?: number,

        views: Array<{
            option: WebcalendarTypes.SyncfusionCalendar_ViewModes,
            interval: number,
            firstDayOfWeek?: number,
            allowVirtualScrolling?: boolean,
            isSelected?: boolean
        }>,
        resources: Array<
            {
                field: string,
                title: string,
                name: string,
                allowMultiple: boolean,
                textField: string,
                idField: string
            }>
    };
}